export default __webpack_public_path__ + "face-svg.svg";